import { useState, useEffect, FormEvent, MouseEvent } from 'react';
import { useParams, useHistory } from 'react-router-dom';

import firebase from 'firebase';
import { toast, ToastContainer } from 'react-toastify';
import { database } from '../services/firebase';
import { useAuth } from '../hooks/useAuth';
import { SalesProps, FirebaseSales, StoreInterface } from '../interfaces/interfaces';

import { Sale } from '../components/Sale';
import { ButtonSignOut } from '../components/ButtonSignOut';
import { BackgroundSVG } from '../components/BackgroundSVG';

import 'react-toastify/dist/ReactToastify.min.css';
import logoCarrano from '../assets/logo.svg';
import '../styles/main.scss';

type StoreParams = {
  id: string;
};

export function Dealer() {
  const history = useHistory();

  const [storeName, setStoreName] = useState<StoreInterface[]>([]);
  const [sales, setSales] = useState<SalesProps[]>([]);
  const params = useParams<StoreParams>();
  const storeId = params.id;
  const { user } = useAuth();

  const [date] = useState(new Date());

  const [quant, setQuant] = useState<any>('');
  const [refer, setRefer] = useState<string>('');
  const [color, setColor] = useState<string>('');
  const [salesforce, setSalesforce] = useState<string>('');

  const [disabled, setDisabled] = useState(false);

  async function signOut(event: MouseEvent) {
    event.preventDefault();

    firebase
      .auth()
      .signOut()
      .then(() => {
        history.push('/');
      })
      .catch(error => {
        alert('Você não esta logado!');
      });
  }

  async function handleSendSales(event: FormEvent) {
    event.preventDefault();
    setDisabled(true);

    if (!user) {
      throw new Error('Você precisa estar logado!');
    }

    if (quant < 33 || quant > 40) {
      setQuant('');
      setDisabled(false);
      return toast.error('A númeração da Carrano vai do 33 ao 40!');
    }
    if (refer.length < 6 || refer.length > 7) {
      setRefer('');
      setDisabled(false);
      return toast.error('Referência inválida, ela deve ter entre 6 e 7 dígitos!');
    } else {
      const AuthorName = user.name;

      const sale = {
        author: {
          name: user?.name,
          avatar: user.avatar,
        },
        refer: refer,
        date: new Date(date).toLocaleDateString('pt-BR'),
        quant: quant,
        color: color,
      };

      const individualSale = {
        storeName,
        storeId,
        salesforce,
        authorName: AuthorName,
        refer: refer,
        date: new Date(date).toLocaleDateString('pt-BR'),
        quant: quant,
        color: color,
      };

      const vendor = {
        refer: refer,
        date: new Date(date).toLocaleDateString('pt-BR'),
        salesforce,
        storeName,
      };

      const referer = {
        refer: refer,
        color: color,
        date: new Date(date).toLocaleDateString('pt-BR'),
      };
      try {
        await database.ref(`sale`).push(individualSale);
        await database.ref(`stores/${storeId}/sales`).push(sale);
        await database.ref(`vendor/${user?.name}/sales`).push(vendor);
        await database.ref(`vendor/${user?.name}/avatar`).set(user?.avatar);
        await database.ref(`styles/${refer}/sales`).push(referer);
        await database.ref(`representantes/${salesforce}/sales`).push(vendor);
        await database.ref(`representantes/${salesforce}/styles/${refer}/sales`).push(referer);
        toast.success('Venda registrada!');
        setQuant('');
        setRefer('');
        setColor('');

        setDisabled(false);
      } catch (err) {
        toast.error('Não foi possível registrar a venda! Favor entrar em contato com o suporte!');
      }
      setDisabled(false);
    }
  }

  useEffect(() => {
    const roomRef = database.ref(`stores/${storeId}/dados`);

    roomRef.orderByChild('name').once('value', store => {
      const databaseStore = store.val().name;
      setStoreName(databaseStore);
    });
  }, [storeId]);

  useEffect(() => {
    const roomRef = database.ref(`stores/${storeId}/dados`);

    roomRef.orderByChild('name').once('value', store => {
      const databaseStore = store.val().salesforce;
      setSalesforce(databaseStore);
    });
  }, [storeId]);

  useEffect(() => {
    const roomRef = database.ref(`stores/${storeId}`);

    roomRef.on('value', store => {
      const databaseStore = store.val();
      const firebaseSales: FirebaseSales = databaseStore.sales ?? {};
      const parsedSales = Object.entries(firebaseSales).map(([key, value]) => {
        return {
          id: key,
          author: value.author,
          quant: value.quant,
          refer: value.refer,
          color: value.color,
          date: value.date,
        };
      });
      setSales(parsedSales);
    });
  }, [storeId]);

  useEffect(() => {
    if (!user) {
      history.push('/');
    }
  });

  return (
    <div className="body-new">
      <BackgroundSVG />
      <div className="header-container">
        <div className="catalog-container">
          {/* <button className='catalog-button' onClick={() => setShow(true)}>Ver lançamentos</button> */}
        </div>
        <div className="logo-container-new">
          <img src={logoCarrano} alt="Logo Carrano" />
          <h1>CADASTRO DE PRODUTOS</h1>
        </div>
        <div className="user-container">
          <span className="user-name">{user?.name}</span>
          <img src={user?.avatar} alt="user-img" className="user-avatar" />
          <ButtonSignOut onClick={signOut} />
        </div>
      </div>
      <section className="section-main">
        <div className="content-container-new">
          <div className="input-box-new">
            <div className="title-of-cards-container">
              <span className="title-of-cards">
                LOJA: <span className="title-of-cards-storename">{storeName}</span>
              </span>
            </div>
            <div className="inputs-new">
              <form onSubmit={handleSendSales}>
                <div className="div-inputs">
                  <input
                    type="text"
                    placeholder="Número (33-40) - U (Acessórios)"
                    name="quant"
                    value={quant}
                    onChange={event => setQuant(event.target.value)}
                    maxLength={2}
                    minLength={2}
                  />
                  <input
                    type="text"
                    placeholder="Referência"
                    name="refer"
                    value={refer}
                    onChange={event => setRefer(event.target.value)}
                    maxLength={7}
                    minLength={6}
                  />
                  <input
                    type="text"
                    placeholder="Cor"
                    name="color"
                    value={color}
                    onChange={event => setColor(event.target.value)}
                    minLength={2}
                  />
                  <button className="addButton" disabled={disabled || !quant || !refer || !color} type="submit">
                    <span className="addButton-icon">ENVIAR</span>
                  </button>
                  <ToastContainer />
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="products-container">
          <div className="products-list">
            <div className="title-of-cards-container">
              <span className="title-of-cards">LISTA DE PRODUTOS CADASTRADOS</span>
            </div>
            {sales.map(sale => {
              return (
                <Sale
                  key={sale.id}
                  id={sale.id}
                  author={sale.author}
                  quant={sale.quant}
                  refer={sale.refer}
                  color={sale.color}
                  date={sale.date}
                />
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}
